import { render, staticRenderFns } from "./ConsultaCadastroOperadora.vue?vue&type=template&id=13cb3bcd&scoped=true&"
import script from "./ConsultaCadastroOperadora.vue?vue&type=script&lang=js&"
export * from "./ConsultaCadastroOperadora.vue?vue&type=script&lang=js&"
import style0 from "./ConsultaCadastroOperadora.vue?vue&type=style&index=0&id=13cb3bcd&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13cb3bcd",
  null
  
)

export default component.exports